export function splitWithBraces(str) {
    function getCommaPositions() {
        let braceCount = 0;
        const commaPositions = [];
        for (let n = 0; n < str.length; n++) {
            if (str.charAt(n) == '{') {
                braceCount++;
            }
            else if (str.charAt(n) == '}') {
                braceCount--;
            }
            else if (str.charAt(n) == ',' && braceCount == 0) {
                commaPositions.push(n);
            }
        }
        return commaPositions;
    }
    const commaPositions = getCommaPositions();
    if (!commaPositions.length) {
        // one value
        return [str];
    }
    else {
        const strs = [];
        for (let n = 0; n < commaPositions.length; n++) {
            if (n == 0) {
                strs.push(str.substr(0, commaPositions[n]));
            }
            else {
                strs.push(str.substr(commaPositions[n - 1] + 1, commaPositions[n] - (commaPositions[n - 1] + 1)));
            }
        }
        if (commaPositions[commaPositions.length - 1] < str.length - 1) {
            strs.push(str.substr(commaPositions[commaPositions.length - 1] + 1));
        }
        else if (commaPositions[commaPositions.length - 1] == str.length - 1) {
            strs.push('');
        }
        return strs;
    }
}
export function trimBraces(str) {
    if (!str || str === '{}') {
        return '';
    }
    if (str.charAt(0) === '{' && str.charAt(str.length - 1) === '}') {
        return str.substr(1, str.length - 2);
    }
    return str;
}
